import {Injectable} from '@angular/core';

import {Store} from '@ngrx/store';

import {PartialToast, Toast} from '@stylehaven/components';
import {DeleteToast, UpdateToast, UpsertToast} from '../../toast/state/toast.actions';
import {ToastState} from '../state/state';

/**
* @deprecated Use ToastHelper
*/
@Injectable()
export class ToastService {
    constructor(private store: Store<{ sharedToast: ToastState }>) {}

    add(toast: Toast): void {
        this.store.dispatch(UpsertToast({ toast }));
    }

    update(toastId: number, toast: PartialToast): void {
        this.store.dispatch(UpdateToast({ id: toastId, toast }));
    }

    delete(toastId: number): void {
        this.store.dispatch(DeleteToast({ id: toastId }));
    }
}
